export const requestStates = {
    DONE: 'DONE',
    ERROR: 'ERROR',
    PENDING: 'PENDING'
};

export const requestTypes = {
    AUDIO_MUTE: 'audioMute',
    CONNECTION: 'connection',
    SCREENSHARE: 'screenshare',
    VIDEO_MUTE: 'videoMute'
};
